export default __webpack_public_path__ + "static/media/icon-network-solana.9f0e7132.svg";